import { createRequestHeader } from '@/assets/js/api.js'
import axios from 'axios';
import { GetAIToken } from '@/axios/ICommon.js'

const { VUE_APP_aiHost, VUE_APP_AI_PROXY } = process.env
const aiHost = VUE_APP_aiHost || ''
const proxy = VUE_APP_AI_PROXY || ''
const t2iUrl = aiHost + proxy + '/text2image-tianmu/api/v1/ai/t2i';

async function createAiRequestHeader() {
  const headers = createRequestHeader(1);
  delete headers.Token;

  const res = await GetAIToken();
  headers['ai-token'] = res?.access_token || '';

  return headers;
}

export const TextToMedia = async(params) => {
  const headers = await createAiRequestHeader();
  const res = await axios.post(t2iUrl, params, {
    timeout: 60000,
    headers,
  });

  return res.data;
}
